/**
 * <s-home-variant-select data-form-id="FORM_ID">
 * Color pills: writes the chosen variant id into the product form, updates the
 * visible label and the URL, and scrolls the gallery to that variant's image.
 */
class HomeVariantSelect extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  #onChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'home-variant') return;

    const form = document.getElementById(this.dataset.formId || '');
    const idInput = form?.querySelector('input[name="id"]');
    if (idInput) idInput.value = input.value;

    const label = this.querySelector('[data-selected-value]');
    if (label) label.textContent = input.dataset.label || '';

    const url = new URL(window.location.href);
    if (url.pathname.includes('/products/')) {
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);
    }

    const mediaId = input.dataset.mediaId;
    if (mediaId) {
      const slide = document.getElementById(`home-media-${mediaId}`);
      const gallery = slide?.parentElement;
      if (slide && gallery && gallery.scrollWidth > gallery.clientWidth) {
        const pad = parseFloat(getComputedStyle(gallery).paddingLeft) || 0;
        gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft - pad, behavior: "smooth" });
      }
    }
  };
}

if (!customElements.get('s-home-variant-select')) customElements.define('s-home-variant-select', HomeVariantSelect);
